module.exports = __webpack_public_path__ + "static/note_main-db6db36e27e209260e654e90d0a9c340.jpg";